<template>
    <div>
        <div class="personalInfo">
            <div class="card-left">
                <div class="top">
                    <i class="iconfont icon-iconcopy"></i>
                    <span>关于我们</span>
                </div>
                <ul class="infos">
                    <li
                            :class="checked === item.id ? 'checked' : ''"
                            :key="item.id"
                            @click="replace(item)"
                            class="info-item"
                            v-for="item in userInfo"
                    >
                        {{ item.text }}
                    </li>
                </ul>
            </div>
            <div class="card-right">
                <!-- 印友简介 -->
                <div class="info yinyou" v-if="checked === 0">
                    <div class="card">
                        <div class="card-top">
                            <span></span>
                            <h3>公司简介</h3>
                        </div>
                        <div class="card-form">
                            <div class="text" v-html="CompanyProfile">
                                {{CompanyProfile}}
                            </div>

                        </div>

                    </div>
                </div>
                <!-- 联系我们 -->
                <div class="info contact" v-if="checked === 1">
                    <div class="card">
                        <div class="card-top">
                            <span></span>
                            <h3>联系我们</h3>
                        </div>
                        <div class="card-form">
                            <div class="text" v-html="contactUs">
                                {{contactUs}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "introduction",
        data() {
            return {
                checked: 0, // 切换模块
                userInfo: [
                    {
                        id: 0,
                        text: "公司简介",
                    },
                    {
                        id: 1,
                        text: "联系我们",
                    }
                ],
                CompanyProfile:'',//公司简介
                contactUs:'',//联系我们
            }
        },

        created() {
            console.log(this.$route.query.id)
            console.log(this.$route.query.checked)

            this.checked=this.$route.query.checked

            this.info()

            // 类型切换
            // let type = localStorage.getItem("type");
            // if (type) {
            //     this.checked = Number(type);
            // } else {
            //     this.checked = 0;
            // }
        },
        methods: {
            // 切换列表
            replace(item) {
                // localStorage.setItem("type", item.id); //存入本地，防止刷新页面丢失
                this.checked = item.id;
                console.log(item);
            },

            info(){
                this.$http.get("/companyprofile/listAll").then((res) => {
                    console.log("公司简介", res);
                    if (res.data.code == 200) {
                        this.CompanyProfile = res.data.data[0].conmpanyProfileContext
                        this.contactUs=res.data.data[0].aboutUsContent
                    } else {
                        this.$message.error("查询失败");
                    }
                })

            }
        }
    }
</script>

<style lang="scss" scoped>
    .personalInfo {
        padding: 20px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .card-left {
            width: 200px;
            height: 320px;

            .top {
                width: 100%;
                height: 86px;
                line-height: 86px;
                text-align: center;
                background-color: #047bd7;
                color: #fff;
                font-size: 24px;

                i {
                    font-size: 28px;
                    margin-right: 10px;
                }
            }

            .infos {
                width: 100%;
                box-sizing: border-box;
                // border: 1px solid #e6e6e6;
                // border-top: none;
                li {
                    box-sizing: border-box;
                    width: 100%;
                    height: 55px;
                    text-align: center;
                    line-height: 55px;
                    border-bottom: 1px dashed #e6e6e6;
                    cursor: pointer;
                }

                li:last-child {
                    border-bottom: none;
                }

                .checked {
                    background-color: #058af2;
                    color: #fff;
                    font-weight: 600;
                }
            }
        }

        .card-right {
            width: 1300px;
            background-color: #fff;
        }

        .info {
            width: 100%;
            box-sizing: border-box;
            // padding: 15px;
        }

        .card {
            width: 100%;
            .card-top {
                display: flex;
                align-items: center;
                height: 50px;
                border-bottom: 1px solid #e6e6e6;
                padding: 0 30px;
                line-height: 50px;

                span {
                    display: inline-block;
                    width: 5px;
                    height: 17px;
                    background: #058af2;
                    margin-right: 20px;
                }

                h3 {
                    color: #058af2;
                }
            }

            .list {
                width: 100%;
                box-sizing: border-box;
                padding: 5px 30px;

                .list-top {
                    display: flex;
                    justify-content: space-between;

                    span {
                        color: #058af2;
                    }

                    span:last-child:hover {
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }

                .list-item {
                    width: 100%;
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    .items {
                        margin-top: 10px;
                        width: 255px;
                        height: 155px;
                        background: transparent url("../../static/imgs/beijing1.png") no-repeat scroll 0% 0%;
                        position: relative;

                        .border {
                            box-sizing: border-box;
                            padding: 15px;
                            font-size: 14px;
                            font-weight: 400;

                            p {
                                padding: 3px 0 5px 0;

                                border-bottom: 1px solid #e6e6e6;
                            }

                            i {
                                display: inline-block;
                                margin-right: 10px;
                            }

                            p:nth-child(2) {
                                height: 65px;
                                display: flex;
                                align-items: center;

                                span {
                                    display: block;
                                    overflow: hidden;
                                    white-space: wrap;
                                    text-overflow: ellipsis;
                                }
                            }

                            p:last-child {
                                border-bottom: none;
                            }
                        }

                        .top {
                            position: absolute;
                            top: 0;
                            right: 15px;
                            font-size: 14px;
                            height: 20px;
                            line-height: 20px;
                            color: #fff;

                            .top-df {
                                display: none;
                                background: #fbb244 none repeat scroll 0% 0%;
                                padding: 0px 10px;
                                border-radius: 0px 0px 5px 5px;
                            }
                        }

                        .active {
                            display: block;
                            padding: 0 10px;
                            background: #058af2 none repeat scroll 0% 0%;
                        }

                        .top:hover {
                            cursor: pointer;
                            text-decoration: underline;
                        }

                        .bottom {
                            display: none;
                            position: absolute;
                            right: 20px;
                            bottom: 8px;
                            cursor: pointer;
                            font-size: 14px;

                            p {
                                float: left;
                                border: 1px solid #d4d4d4;
                                margin-left: 5px;
                                height: 25px;
                                line-height: 25px;
                                width: 40px;
                                text-align: center;
                                border-radius: 3px;
                                background-color: #fff;
                            }

                            p:hover {
                                color: #058af2;
                            }
                        }
                    }

                    .items-bgd {
                        background: transparent url("../../static/imgs/beijing2.png") no-repeat scroll 0% 0%;
                    }

                    .items:hover .top-df {
                        display: block;
                    }

                    .items:hover .bottom {
                        display: block;
                    }

                    .items:nth-last-child(-n + 1) {
                        height: 0;
                        background: none;
                    }
                }
            }
        }

        /*印友简介*/
        .yinyou {
            .card-form {
                margin: 30px;
                span{
                    font-weight: bold;
                }
                div{
                    margin: 10px 0;
                    text-indent: 2rem;
                    line-height: 30px;
                }
                img{
                    display: block;
                    margin: auto;
                }
            }
        }

        /*联系我们*/
        .contact {
            .card-form {
                margin: 30px;
                div{
                    margin: 10px 0;
                    line-height: 30px;
                    font-weight: bold;
                }
                span{
                    font-weight: initial;
                }
            }
        }
    }
</style>